import { Document, Font, Page, StyleSheet, Text } from '@react-pdf/renderer';
import { useMemo } from 'react';
import type { CdaParser } from '../../parsers/cda-parser';
import type { CdaDocument } from '../../parsers/types';
import { styles as headingStyles } from './pdf-heading-renderer';
import { PdfSectionRenderer } from './pdf-section-renderer';
import { PdfTableOfContentsRenderer } from './pdf-table-of-contents-renderer';
Font.register({
  family: 'Inter',
  fontStyle: 'normal',
  fontWeight: 400,
  src: '/Inter-400.ttf',
  fonts: [
    {
      fontWeight: 400,
      src: '/Inter-400.ttf',
    },
    {
      fontWeight: 500,
      src: '/Inter-500.ttf',
    },
    {
      fontWeight: 600,
      src: '/Inter-600.ttf',
    },
  ],
});

// Define styles for the PDF
export const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontFamily: 'Inter',
    fontWeight: 400,
    gap: 10,
  },
  container: {
    fontFamily: 'Inter',
    marginBottom: 10,
    flexGrow: 1,
  },
  text: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 1.5,
  },
  link: {
    color: '#036240',
    textDecoration: 'none',
  },
  title: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 16,
  },
});

export const PdfCdaRenderer = ({
  cdaParser,
}: {
  cdaParser: CdaParser;
  key?: string;
}) => {
  const data: CdaDocument = useMemo(() => cdaParser.toDocumentJson(), [cdaParser]);

  return (
    <Document style={styles.container} title={data?.metadata?.xml.title}>
      <Page size="A4" style={styles.page}>
        <Text style={headingStyles.h1}>{data?.metadata?.xml.title}</Text>
        <PdfTableOfContentsRenderer data={data} />
        {(data?.content?.sections || []).map((section, index) => (
          <PdfSectionRenderer key={`section-${section.id}-${index}`} section={section} />
        ))}
      </Page>
    </Document>
  );
};
